import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface EntryCrestData {
  id: number;
  name: string;
  club_badge_src: string | null;
  onCancel?: () => void;
}

interface UiSliceState {
  sheets: {
    crest: {
      entryCrestData: EntryCrestData | null;
    };
  };
}

const initialState: UiSliceState = {
  sheets: {
    crest: {
      entryCrestData: null,
    },
  },
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openCrestSheet: (state, action: PayloadAction<EntryCrestData>) => {
      state.sheets.crest.entryCrestData = action.payload;
    },
    closeCrestSheet: (state) => {
      state.sheets.crest.entryCrestData = null;
    },
  },
});

export const { openCrestSheet, closeCrestSheet } = uiSlice.actions;
export default uiSlice.reducer;
